import { render, staticRenderFns } from "./nbn-appointment-results.vue?vue&type=template&id=646975a3&scoped=true"
import script from "./nbn-appointment-results.vue?vue&type=script&lang=js"
export * from "./nbn-appointment-results.vue?vue&type=script&lang=js"
import style0 from "./nbn-appointment-results.vue?vue&type=style&index=0&id=646975a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646975a3",
  null
  
)

export default component.exports